/**
 * Small shared building blocks for the redesigned dashboard overview (NAU-247).
 */

import { FeatherInfo } from "@subframe/core";

export function OverviewCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`flex flex-col rounded-md border border-solid border-neutral-border bg-white ${className ?? ""}`}
    >
      {children}
    </div>
  );
}

export function SectionHeader({
  title,
  count,
  action,
}: {
  title: string;
  count?: number;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="text-heading-3 font-heading-3 text-primary-navy-800">
          {title}
        </span>
        {count !== undefined && count > 0 && (
          <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-error-500 px-1.5 text-caption-bold font-caption-bold text-white">
            {count}
          </span>
        )}
      </div>
      {action}
    </div>
  );
}

/**
 * A subtle marker for widgets backed by mock data until the backend
 * aggregation query exists. Keeps the demo honest at a glance.
 */
export function DemoBadge() {
  return (
    <span
      title="Sample data — needs the new dashboard API"
      className="flex items-center gap-1 rounded-full border border-solid border-neutral-200 bg-neutral-50 px-2 py-0.5 text-caption font-caption text-subtext-color"
    >
      <FeatherInfo className="text-caption" />
      Demo
    </span>
  );
}
